import Translations from "translations/types";

export const RECEIVER_SETTINGS_KEY = "receiver_settings" as const;

const RECEIVER_SETTINGS_STEPS = {
  CAPACITY: "capacity",
  REVERSE_SEARCH: "reverse_search",
  SERVICES: "services",
} as const;

export const RECEIVER_SETTINGS = {
  doneLabel: (t: Translations) => t.tours.reverseSearch.doneButton,
  key: RECEIVER_SETTINGS_KEY,
  nextLabel: (t: Translations) => t.tours.reverseSearch.nextButton,
  prevLabel: (t: Translations) => t.tours.reverseSearch.backButton,
  steps: {
    [RECEIVER_SETTINGS_STEPS.CAPACITY]: {
      intro: (t: Translations) => t.tours.receiverSettings.stepC.intro,
      key: RECEIVER_SETTINGS_STEPS.CAPACITY,
      step: 3,
      title: (t: Translations) => t.tours.receiverSettings.stepC.title,
    },
    [RECEIVER_SETTINGS_STEPS.REVERSE_SEARCH]: {
      intro: (t: Translations) => t.tours.receiverSettings.stepB.intro,
      key: RECEIVER_SETTINGS_STEPS.REVERSE_SEARCH,
      step: 2,
      title: (t: Translations) => t.tours.receiverSettings.stepB.title,
    },
    [RECEIVER_SETTINGS_STEPS.SERVICES]: {
      intro: (t: Translations) => t.tours.receiverSettings.stepA.intro,
      key: RECEIVER_SETTINGS_STEPS.SERVICES,
      step: 1,
      title: (t: Translations) => t.tours.receiverSettings.stepA.title,
    },
  },
} as const;
